/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Button from "../../../components/Button";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ControlTable } from "../../../components/Table";
import Icon from "../../../components/Icon";
import systemAlert from "../../../utils/systemAlert";

import { getExpenseOptionsList, deleteExpenseOption, modifyExpenseOptionOrder } from "../../../apis/expense";

// Icon
import AddDocIcon from "../../../assets/images/person/add-doc-icon.svg";
import ArrowTopIcon from "../../../assets/images/person/arrow-top-icon.svg";
import ArrowBottomIcon from "../../../assets/images/person/arrow-bottom-icon.svg";
import CheckIcon from "../../../assets/images/icon/check-icon.svg";
import ExpenseOptionDetail from "./ExpenseOptionDetail";

const ExpenseOption = ({ open, setOpen }) => {

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [fields, setFields] = useState([]);
  const [checkIdx, setCheckIdx] = useState(0);
  const [order, setOrder] = useState(false);

  const [openDetail, setOpenDetail] = useState(false);
  const [mode, setMode] = useState("create");

  const _getData = () => {

    setIsLoading(true);

    getExpenseOptionsList()
      .then((res) => {
        //console.log("data: ", res)
        setList(res);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });

  };

  useEffect(() => {
    if (open) {
      _getData();
    }
  }, [open]);

  useEffect(() => {
    setFields([
      {
        title: "",
        key: "idx",
        width: "50px",
        onValue: (val, fields, data) => {
          if (data.idx === checkIdx) {
            return (
              <Icon src={CheckIcon}></Icon>
            );
          } else {
            return (<></>);
          }
        }
      },

      { title: "비용명", key: "name", },
    ]);
  }, [checkIdx, list]);

  const changeArrayOrder = async (move) => {

    const tempList = list.map((data) => data);
    if (tempList.length < 0) return;

    let targetIndex = -1;
    tempList.forEach((data, index) => {
      if (data.idx === checkIdx) {
        targetIndex = index;
      }
    });

    if (targetIndex < 0) return;

    const newPosition = targetIndex + move;
    if (newPosition < 0 || newPosition >= tempList.length) return;

    const target = tempList.splice(targetIndex, 1)[0];
    tempList.splice(newPosition, 0, target);

    setList(tempList);
    setOrder(true);
  };

  const modifyOrder = async () => {
    setIsLoading(true);

    const nameList = list.map(data => {
      return {
        idx: data.idx,
        name: data.name
      };
    });
    modifyExpenseOptionOrder({ list: nameList })
      .then(() => {
        _getData();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const tableButtons = [
    {
      label: "저장하기",
      size: 'sm',
      action: async () => {
        systemAlert(`저장 하시겠습니까?`, {

          buttons: [
            {
              color: 'text',
              label: '취소',
            },
            {
              label: '저장',
              onClick: async () => {
                await modifyOrder();
              }
            }
          ]
        });
      },
      disabled: order === false,
    },
    {
      label: (
        <>
          <Icon src={ArrowTopIcon} />
        </>
      ),
      size: 'sm',
      color: "gray-line",
      action: async () => {
        changeArrayOrder(-1);
      },
      disabled: checkIdx < 1,
    },
    {
      label: (
        <>
          <Icon src={ArrowBottomIcon} />
        </>
      ),
      size: 'sm',
      color: "gray-line",
      action: async () => {
        changeArrayOrder(1);
      },
      disabled: checkIdx < 1,
    },
    {
      label: (
        <>
          <Icon src={AddDocIcon} />
        </>
      ),
      size: 'sm',
      color: "gray-line",
      action: () => {
        if (order) {
          systemAlert(`정렬순서 변경 이력이 있습니다. \n저장 하시겠습니까?`, {

            buttons: [
              {
                color: 'text',
                label: '취소',
                onClick: () => {
                  setMode("create");
                  setOpenDetail(true);
                }
              },
              {
                label: '저장',
                onClick: async () => {
                  await modifyOrder();
                  setMode("create");
                  setOpenDetail(true);
                }
              }
            ]
          });
        } else {
          setMode("create");
          setOpenDetail(true);
        }
      },
    },
  ];

  const cancel = () => {
    setOpen(false);
    window.location.reload();
  };

  const onRowClick = (data) => {
    setCheckIdx(data.idx);
  };

  const rowBtnConfig = {
    title: '',
    rowButtons: [
      /*
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setCheckIdx(0)
          setOpenDetail(true)
        },
      },
      */
      {
        label: "삭제",
        type: "delete",
        action: (data) => {
          if (data.idx > 0) {
            systemAlert(`삭제 하시겠습니까?`, {
              buttons: [
                {
                  color: 'text',
                  label: '취소',
                },
                {
                  label: '승인',
                  onClick: () => {
                    deleteExpenseOption(data.idx)
                      .then(() => {
                        _getData();
                      });
                  }
                }
              ]
            });
          }
        },
      },
    ],
  };

  return (
    <Modal isOpen={open} close={cancel} size="sm">
      <div className="select-client-info">
        <ModalHeader>비용항목 관리</ModalHeader>
        <ControlTable
          isHideHeader
          fields={fields}
          list={list}
          isLoading={isLoading}
          onSelect={onRowClick}
          buttons={tableButtons}
          //submit={handleSubmit}

          rowBtn={rowBtnConfig}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            //size="lg"
            label="닫기"
            color="gray-line"
            action={cancel}
          />
        </div>
        <ExpenseOptionDetail
          open={openDetail}
          setOpen={setOpenDetail}
          mode={mode}
          submit={_getData}
        />
      </div>
    </Modal>
  );
};

export default ExpenseOption;
